import { render, staticRenderFns } from "./addSMS.vue?vue&type=template&id=24a5a6ba"
import script from "./addSMS.vue?vue&type=script&lang=js"
export * from "./addSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports